module.exports = __webpack_public_path__ + "img/CMS.dfd76425.png";